/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { TimeFilter, PageType } from 'src/app/models/enums';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { EventsService } from 'src/app/services/events.service';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { SportsService } from 'src/app/services/sports.service';
import { StorageService } from 'src/app/services/util/storage.service';

@Component({
  selector: 'app-results-navigation',
  templateUrl: './results-navigation.component.html',
  styleUrls: ['./results-navigation.component.less']
})
export class ResultsNavigationComponent implements OnInit, AfterViewInit {

  last7Days: Date[] = [];

  timeFilterValue: TimeFilter;
  timeFilterValueEnum = TimeFilter;
  eventsTimeLeagueFilter = false;
  eventsPopularNextFilter = true;
  public pageType: PageType;
  public pageTypeEnum = PageType;
  today: Date = new Date();
  D1: Date = new Date(this.today.getTime() - (24 * 60 * 60 * 1000));
  D2: Date = new Date(this.today.getTime() - (48 * 60 * 60 * 1000));
  D3: Date = new Date(this.today.getTime() - (72 * 60 * 60 * 1000));
  D4: Date = new Date(this.today.getTime() - (96 * 60 * 60 * 1000));
  D5: Date = new Date(this.today.getTime() - (120 * 60 * 60 * 1000));
  D6: Date = new Date(this.today.getTime() - (144 * 60 * 60 * 1000));


  @Input()
  isLive: boolean;

  constructor(
    private sportsService: SportsService,
    private queryParams: QueryParamsService,
    private storage: StorageService) {
      this.timeFilterValue = TimeFilter.ResultToday;
     }

  ngOnInit(): void {

    this.pageType = this.queryParams.pageType;
    // this.queryParams.pageTypeChanged$.subscribe(pageType => {
    //   this.pageType = pageType;
    // });
  }

  ngAfterViewInit(): void {

    this.sportsService.changeTimeFilterValue(this.timeFilterValue, false);
  }

  timeFilterValueChange(timeFilterValue: TimeFilter, pageType: PageType) {
    if (this.timeFilterValue !== timeFilterValue) {
      this.timeFilterValue = timeFilterValue;
      this.sportsService.changeTimeFilterValue(timeFilterValue, false);
    }
    // if (this.timeFilterValue !== timeFilterValue) {
    //   this.timeFilterValue = timeFilterValue;
    //   if (pageType === this.pageType) {
    //     this.sportsService.changeTimeFilterValue(timeFilterValue, false);
    //   }
    // }
    // if (pageType !== this.pageType) {
    //   this.storage.pageType = this.queryParams.pageType;
    //   this.queryParams.pageType = pageType;
    //   this.sportsService.changeTimeFilterValue(timeFilterValue, false, false);

    //   if (pageType === PageType.Prematch || pageType === PageType.Soon) {
    //     this.changPageToPrematch();
    //   }

    //   if (pageType === PageType.Live) {
    //     this.changPageToLive();
    //   }
    // }
  }

  changPageToLive() {
    if (this.isLive) {
      return;
    }
    const url = window.location.href;
    window.location.assign(url.replace('results', 'betting/live'));
  }

  changPageToPrematch() {
    const url = window.location.href;
    window.location.assign(url.replace('results', 'betting/prematch'));
  }


}
